/*
 * @Author: your name
 * @Date: 2021-08-04 15:25:39
 * @LastEditTime: 2021-12-04 16:59:13
 * @LastEditors: lks
 * @Description: In User Settings Edit
 */
import { RouteConfig } from "vue-router";

const merchantRoute: RouteConfig[] = [
  {
    path: "/merchant.html",
    name: "merchant",
    component: () => import("@/views/merchant/index.vue"),
    meta: { title: "商户申请", parentTab: "merchant" },
  },
];
export { merchantRoute };
